import './faq-content.scss'

export const component = {
    name: 'faq-content',

    mounted () {
        console.log('faqqq')
    }
}


// WEBPACK FOOTER //
// ./app/theme/components/faq-content/faq-content.js